import { Link, useParams } from 'react-router-dom';

import { BUCKETS, CATEGORIES, LINKS } from '../data/metaData.js';
import { makeKey, getDataForChain } from '../data/getData.js';
import {
	ICONS,
	PROJECT_SUBMISSION_FORM_URL,
} from '../data/constants.js';

import VerifiedIcon from './VerifiedIcon';

const Projects = () => {
	const { chain: selectedChain, tag: selectedTag } = useParams();
	const { processedData } = getDataForChain(selectedChain);

	const renderSidebar = () => {
		return (
			CATEGORIES.map(category => {
				if (!processedData[makeKey(category)]) return null
				return (
					<div key={category}>
						<Link
							className="menu-parent null"
							to={`/${selectedChain}/projects/${category}`}>
								{category}
								<span className="menu-badge">{processedData[makeKey(category)].total}</span>
						</Link>
						<ul  className="menu menu-nav">
							{
								BUCKETS[category].map(
									(tag, index) => index === 0 || !processedData[makeKey(tag)] ? null : (
										<li key={tag} className="menu-item">
											<Link
												to={`/${selectedChain}/projects/${makeKey(tag)}`}
												className="near-title null"
											>
												{tag}
												<span className="menu-badge">{
													processedData[makeKey(tag)].total
												}</span>
											</Link>
										</li>
									)
								)
							}
						</ul>
					</div>
				)
			})
		)
	};

	const renderTiles = () => {
		if (selectedTag && !processedData[selectedTag]) return (<p>No Data...</p>);
		const projects = selectedTag ? processedData[selectedTag].projects : processedData.projects;
		return (
			projects.map(({ name, tags, description, image, links, isVerified = false }) => (
				<div key={name} className="column col-4 col-lg-6 col-sm-12">
					<Link className="near-item mainnet" title={name} to={`/${selectedChain}/detail/${name.replaceAll(' ', '-')}`}>
						<div className="near-item-header">
							<div className="tile">
								<div className="tile-icon">
									<img src={image} alt={name}/>
								</div>
								<div className="tile-content">
									<h2 className="tile-title">
										<span>{name}</span>
										{isVerified && <VerifiedIcon />}
									</h2>
									<div className="tile-tags">{tags.map(tag => (<span key={tag}>{tag}</span>))}</div>
								</div>
							</div>
							<div className="tile">
								<h3 className="tile-subtitle">{description}</h3>
							</div>
						</div>
						<div className="near-item-footer">
							<div className="tile-social">
								{LINKS.map(link => (
									links[link]
										? <img
											alt={link}
											className="icon"
											height="20"
											key={link}
											src={ICONS[link]}
											width="20"
										/>
										: null
								))}
							</div>
							<div className="tile-series"></div>
						</div>
					</Link>
				</div>
			))
		);
	};

	return (
		<div className="section-main">
			<div className="container grid-xl">
				<div className="columns">
					<div className="hero-container column col-12">
						<div className="awesome-hero">
							<div className="hero-content">
								<h1 className="hero-title">{selectedTag || 'Projects'}</h1>
								<h2 className="hero-subtitle">ALL projects building on the Ethereum POW ecosystem.</h2>
							</div>
						</div>
					</div>
				</div>
				<div className="columns" id="scrollableParent">
					<div className="aside-container column">
						<div className="sidebar-container">
							<nav className="near-aside-menu">
								<div>
									<Link
										className="menu-parent active"
										to={`/${selectedChain}/projects`}>
											All
											<span className="menu-badge">{processedData.total}</span>
									</Link>
								</div>
								{renderSidebar()}
							</nav>
							<div className="menu-ads">
								<a
									className="btn btn-primary btn-block mt-2"
									href={PROJECT_SUBMISSION_FORM_URL}
									rel="noreferrer"
									target="_blank"
								>
										Submit a project ↗
								</a>
							</div>
						</div>
					</div>
					<div className="content-container column col-9 col-md-12">
						<div className="near-content">
							<div className="near-list-container columns">
								{renderTiles()}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Projects;
